function EmptyContributorIc({
    FrontCard,
    isShowTitle=false,
    width = 'w-[331px]',
    height = 'h-[363px]',
    fixW,
    image,
    ic,
   
}) {
    return (
        <div className={` rounded ${fixW} mr-5`}>
            <div className={`  relative ${width} ${height}  `}>
                <div className="absolute top-0 left-0   h-[100%] front">{<FrontCard isShowTitle={true}  ic={ic} image={image} />}</div>
              
            </div>
        </div>
    );
}

export default EmptyContributorIc;
